module.exports = __webpack_public_path__ + "static/media/redo-alt.55a0c503.svg";